import type { ReactNode } from 'react';

export function Panel({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={`rounded-2xl border border-white/10 bg-slate-900/80 shadow-xl backdrop-blur ${className}`}
    >
      {children}
    </div>
  );
}

export function BigButton({
  children,
  onClick,
  variant = 'primary',
  disabled = false,
  className = '',
}: {
  children: ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'ghost' | 'danger';
  disabled?: boolean;
  className?: string;
}) {
  const styles =
    variant === 'primary'
      ? 'bg-sky-500 hover:bg-sky-400 text-slate-950 font-semibold'
      : variant === 'danger'
        ? 'bg-rose-600/80 hover:bg-rose-500 text-white'
        : 'bg-white/10 hover:bg-white/20 text-white';
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`max-w-full whitespace-normal break-words rounded-xl px-5 py-3 text-base transition disabled:cursor-not-allowed disabled:opacity-40 ${styles} ${className}`}
    >
      {children}
    </button>
  );
}

export function Stars({ n }: { n: 0 | 1 | 2 | 3 }) {
  return (
    <span className="text-xl tracking-wide" aria-label={`${n}/3`}>
      {[1, 2, 3].map((i) => (
        <span key={i} className={i <= n ? 'text-amber-400' : 'text-white/20'}>
          ★
        </span>
      ))}
    </span>
  );
}

export function ScreenShell({ children }: { children: ReactNode }) {
  return (
    <div className="screen-shell h-full min-h-0 w-full overflow-x-hidden overflow-y-auto overscroll-y-contain bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <div className="mx-auto flex min-h-full w-full max-w-5xl flex-col gap-4 px-4 py-5 pb-[max(1.25rem,env(safe-area-inset-bottom))] sm:gap-6 sm:px-6 sm:py-10">
        {children}
      </div>
    </div>
  );
}
